// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForFlex = makeThemedStyles('Flex', () => ({
  Flex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}));

type ElementProps = React.ComponentProps<React.HTMLFactory<HTMLElementTagNameMap['div']>>;

export const Flex: React.FunctionComponent<ElementProps> = (props: ElementProps) => {
  const styles = useStylesForFlex();

  /* eslint-disable */
  return (
    <div {...props} style={{ ...(props?.style || {}), ...{} }} className={clsx(styles.Flex)}>
      {props?.children}
    </div>
  );
};
export default Flex;
